import React, { Ref, forwardRef } from "react";
import styleSheet from "./style.module.scss";
import SyIcon from "../sy-icon";
import { ButtonData } from "./interface";
const OrbButton: React.FC<ButtonData> = forwardRef(({
  label,
  type = "button",
  className = "",
  disabled,
  id,
  size = "sm",
  value = "",
  loading=false,
  onBtnClick,

  iconName,
  iconType,
  iconStyle,
  iconColor = "#00000066",
  btnColor = "default",
}, ref:any) => {
  const onClick = () => {
    onBtnClick && onBtnClick(value);
  };
  const onIconClick = () => {
    onBtnClick && onBtnClick(value);
  };
  

  if (!label && !iconName) {
    return null;
  }
  return (
    <button
      ref={ref}
      type={type}
      className={`${className} ${
        btnColor === "default"
          ? styleSheet.btn_style
          : styleSheet.btn_style_success
      } rounded `}
      value={value}
      onClick={onClick}
      disabled={disabled}
      id={id}
    >
      
      <div
        className={`
          d-flex align-items-center justify-content-center px-2 py-1 `}
      >
         {loading &&   (<div className={`${styleSheet.loading}  spinner-border me-2`} role="status"  style={{ color: iconColor }}></div>)}
        {iconName && !loading && (
          <SyIcon
            name={iconName}
            iconType={iconType}
            iconStyle={iconStyle}
            className={`pe-2`}
            iconColor={iconColor}
            // loading={loading}
            // onClick={onIconClick}
          />
        )}
       
        {label && <p className="m-0 mohave-bold text-nowrap">{label}</p>}
      </div>
    </button>
  );
});

export default OrbButton;
